import { useEffect, useState } from 'react';
// material
import { Container, Stack, Typography } from '@mui/material';
// components
import GoogleMapReact from 'google-map-react';

import Page from '../components/Page';
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';
// mock
import PRODUCTS from '../_mock/products';

// ----------------------------------------------------------------------

export default function EcommerceShop() {
  const [openFilter, setOpenFilter] = useState(false);
  const [latitude, setLat] = useState(0.00000);
  const [longitude, setLng] = useState(0.00000);
  const [ projects, setProjects ] = useState([]);
  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  async function getLocation() {
    if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(showPosition);
    } else { 
      alert("We need your location to improve your experience in the app")
    }
  }
  
  function showPosition(position) {
    setLat(position.coords.latitude);
    setLng(position.coords.longitude);
  }
  const AnyReactComponent = ({ text, image, obj }) => <div>
    <a href="#" onClick={() => {
      localStorage.setItem("project_id", obj.id);
      localStorage.setItem("project_json", JSON.stringify(obj));
      window.location.href = './project-details'
    }}>
    <img src={image} width="50px" height="50px" alt="Icon" />
    <div style={{ width: 100, background: "green", padding: 10, borderRadius: 10}}><p style={{textAlign: "center", color: "#fff", fontWeight: "800", fontSize: 9}}>{text}</p></div>
    </a>
  </div>;
  const defaultProps = {
    center: {
      lat: latitude,
      lng: longitude
    },
    zoom: 5
  };
  useEffect(() => {
    
    getLocation();
    fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/projects/location/find?longitude=${latitude}&latitude=${longitude}`, {
        
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(resposne => resposne.json())
      .then(data => {
        console.log(data);
        setProjects(data.data)
      })
      .catch(err => {
        alert(`Error: ${err}`);
      })
    
  }, [])
  return (
    <Page title="Dashboard: Products">
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Projects near you
        </Typography>

        {/* <Stack direction="row" flexWrap="wrap-reverse" alignItems="center" justifyContent="flex-end" sx={{ mb: 5 }}>
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <ProductFilterSidebar
              isOpenFilter={openFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
            />
            <ProductSort />
          </Stack>
        </Stack> */}
        <div style={{ height: '60vh', width: '100%' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyCsR3wn4kMoutr1tB-kEOBnymzps2YWr3g" }}
            defaultCenter={{
              lat: latitude,
              lng: longitude
            }}
            defaultZoom={defaultProps.zoom}
          >
            {
              projects.map((obj, index) => {
                return(
                  <AnyReactComponent
                    lat={obj.location.coordinates[1]}
                    lng={obj.location.coordinates[0]}
                    text={obj.name}
                    obj={obj}
                    image="https://cdn.iconscout.com/icon/free/png-256/user-location-2433522-2019037.png"
                  />
                )
              })
            }
            
          </GoogleMapReact>
        </div>
        {/* <ProductList products={projects} /> */}
        {/* <ProductCartWidget /> */}
      </Container>
    </Page>
  );
}
